export { NewsModule } from './news.module'
export { loadNewsOverview } from './state/actions'
export { newsFeedRoute, newsItemRoute, newsOverviewRoute } from "./constants";
export { NewsOverviewShellComponent } from "./news-overview-shell/news-overview-shell.component";
export { NewsItemComponent } from "./news-item-shell/news-item-shell.component";
export { NewsFeedShellComponent } from "./news-feed-shell/news-feed-shell.component";

